import { api } from '@/services'

export function list(params) {
  return api.get('/admin/serviceProvider/list', { params })
}

export function show(id) {
  return api.get(`/admin/serviceProvider/show/${id}`)
}

export function create(body) {
  return api.post('/admin/serviceProvider/create', body)
}

export function update(body) {
  return api.post(`/admin/serviceProvider/update`, body)
}

export function remove(id) {
  return api.delete(`/admin/serviceProvider/delete/${id}`)
}

// link and unlink stuff
export function link(body) {
  return api.post('/admin/serviceProviderCustomer/link', body)
}

export function unlink(body) {
  return api.post('/admin/serviceProviderCustomer/unlink', body)
}

export function listServiceProviderCustomer(params) {
  return api.get('/admin/serviceProviderCustomer/list', { params })
}

// service provider user
export function listServiceProviderUsers(params) {
  return api.get('/web/serviceProvider/list', { params })
}

export function showServiceProviderUser(id) {
  return api.get(`/web/serviceProvider/show/${id}`)
}

export function createServiceProviderUser(body) {
  return api.post('/web/serviceProvider/create', body)
}

export function updateServiceProviderUser(body) {
  return api.post(`/web/serviceProvider/update/${body.id}`, body)
}

export function removeServiceProviderUser(id) {
  return api.delete(`/web/serviceProvider/delete/${id}`)
}

export function listServiceProviderUsersFiltered(params) {
  return api.get('/web/serviceProvider/list', { params })
}

export function listServiceProviderCustomers(params) {
  return api.get('/web/serviceProvider/listCustomers', { params })
}

export function createServiceProviderContract(body) {
  return api.post('/web/serviceProviderContract/create', body)
}

export function createServiceProviderRealEstate(body, config = {}) {
  return api.post('/serviceProvider/realEstate/create', body, config)
}

export function showServiceProviderContractByRealEstate(realEstateId) {
  return api.get(`/web/serviceProviderContract/show/${realEstateId}`)
}

export function updateServiceProviderRealEstate(body, config = {}) {
  return api.put(`/serviceProvider/realEstate/update/${body.id}`, body, config)
}

export function deleteServiceProviderRealEstate(id, body = null, config = {}) {
  return api.delete(`/serviceProvider/realEstate/delete/${id}`, body ? { ...config, data: body } : config)
}

export function listServiceProviderContractServiceTypes() {
  return api.get('/web/serviceProviderContract/serviceTypes')
}

export function addServiceProviderBalance(body) {
  return api.post('/web/serviceProvider/movement/addBalance', body)
}

export function getRealEstateLogoUploadUrl(body) {
  return api.post('/serviceProvider/realEstate/logoUploadURL', body)
}

export function addRealEstateLogo(body) {
  return api.post('/serviceProvider/realEstate/addLogo', body)
}

export function getServiceProviderLogoUploadUrl(body) {
  return api.post('/admin/serviceProvider/logoUploadURL', body)
}

export function addServiceProviderLogo(body) {
  return api.post('/admin/serviceProvider/addLogo', body)
}
